<template>
  <div class="centerx labelx">
    <vs-row class="mt-1" vs-w="12">
      <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
        <vs-select
          autocomplete
          color="success"
          width="310px"
          class="selectExample ml-3 mb-1"
          label="Network"
          v-model="select1"
          @change="actionchange(select1)"
        >
          <vs-select-item
            :key="item.id"
            :value="item"
            :text="item.name"
            v-for="item in nwlist"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col
        class="mb-3"
        vs-type="flex"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
      >
        <div>
          <label class="ml-4 labelInput" for="fname"
            >Serial Code
            <iconStar />
          </label>
          <vs-input
            color="#333f50"
            style="width: 310px"
            class="inputx ml-3"
            type="string"
            placeholder="Code"
            v-model="serial"
            @change="datachange"
          />
        </div>
      </vs-col>
      <vs-col
        class="mb-3"
        vs-type="flex"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
      >
        <div>
          <label class="ml-4 labelInput" for="fname"
            >Security Code <iconStar
          /></label>
          <vs-input
            color="#333f50"
            style="width: 310px"
            class="inputx ml-3"
            type="string"
            placeholder="Code"
            v-model="security"
            @change="datachange"
          />
        </div>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col
        class="mb-3"
        vs-type="flex"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
      >
        <div>
          <label class="ml-4 labelInput" for="fname"
            >Device Name <iconStar
          /></label>
          <vs-input
            color="#333f50"
            style="width: 310px"
            class="inputx ml-3"
            type="string"
            placeholder="Default Name"
            v-model="sensor.name"
          />
        </div>
      </vs-col>
      <vs-col
        class="mb-3"
        vs-type="flex"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
      >
        <vs-input
          color="#333f50"
          style="width: 310px"
          v-if="sensor.name != null"
          class="inputx ml-3"
          label="Sensor Type"
          type="string"
          readonly
          placeholder="Type"
          v-model="sensor.type"
        />
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
        <vs-input
          color="#333f50"
          v-if="sensor.subtype != null"
          style="width: 310px"
          class="inputx ml-3"
          label="Sensor Subtype"
          type="string"
          readonly
          placeholder="Type"
          v-model="sensor.subtype"
        />
      </vs-col>
    </vs-row>

    <vs-row class="ml-3 mt-3" vs-w="12">
      <vs-spacer />
      <vs-button
        type="filled"
        size="sm"
        style="border-radius: 20px"
        color="success"
        @click="adddev()"
        :disabled="!sensor.type"
        >Add Device</vs-button
      >
      
      <vs-button
        class="ml-2 mr-4"
        type="flat"
        color="dark"
        @click="cancel()"
        style="border-radius: 20px"
      >
        Cancel
      </vs-button>
    </vs-row>
  </div>
</template>

<script>
import iconStar from "../Button/iconStar.vue";
export default {
  name: "AddDevice",
  props: ["locName"],
  data: () => ({
    nwlist: [],
    serial: "",
    security: "",
    select1: "",
    name: "",
    type: "",
    sensor: {
      id: null,
      name: null,
      serial: null,
      security: null,
      type: null,
      subtype: null,
    },
  }),
  components: {
    iconStar,
  },
  methods: {
    cancel() {
      // location.reload();
    },
    datachange() {
      if (
        this.serial != null &&
        this.serial != "" &&
        this.security != null &&
        this.security != ""
      ) {
        this.$API
          .get("searchsensor/" + this.serial + "/" + this.security)
          .then((result) => {
            this.sensor = result.data[0];
            // console.log(result.data)
          });
      } else {
        this.sensor.name = null;
        this.sensor.type = null;
        this.sensor.subtype = null;
      }
    },
    actionchange(item) {
      this.nwname = item.name;
      this.nwid = item.id;
    },
    adddev() {
      if (
        this.nwname != "" &&
        this.sensor.serial != "" &&
        this.sensor.security != "" &&
        this.sensor.name != ""
      ) {
        this.$API
          .post("device", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            name: this.sensor.name,
            serial_id: this.sensor.serial,
            security_id: this.sensor.security,
            network: this.nwname,
            nwid: this.nwid,
            lora: this.sensor.loraeui || "",
            token: this.$session.get("token"),
            type: this.sensor.type,
            subtype: this.sensor.subtype,
            location: this.locName
          })
          .then(() => {
            this.$vs.notify({
              title: "Add Device",
              text: "Complete!",
              color: "success",
              position: "top-center",
              icon: "check",
            });
            setTimeout(() => {
              this.clear();
            }, 300);
          });
      } else {
        this.$vs.notify({
          title: "Add Device",
          text: "Please fill in the form",
          color: "danger",
          position: "top-center",
          icon: "cancel",
        });
      }
    },
    clear() {
      this.nwname = "";
      this.name = "";
      this.security = "";
      this.serial = "";
      this.type = "";
      this.nwid = 0;
      setTimeout(() => {
        location.reload();
      }, 300);
    },
  },
  created() {
    console.log(this.locName)
    this.$API.get("network/user").then((result) => {
      this.nwlist = result.data;
    });
  },
};
</script>
<style scoped>
.labelInput {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.7);
}
.spanColor {
  /* content:" *";  */
  font-size: 20px;
  color: red;
  padding-top: 10px;
}
</style>